import { RouteConfig } from "vue-router";
import { Permission } from "@/utils/permissions";

const engineModelRouter: Array<RouteConfig> = [
  {
    path: "engines/:id",
    name: "engineModelId",
    component: () => import("@/views/EngineModels/Model.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  },
  {
    path: "engines/create_engine",
    name: "new_engine_model",
    component: () => import("@/views/EngineModels/NewModel.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  }
];

export default engineModelRouter;
